import {WeaTools} from 'ecCom';
const staticVersion = `?v${WeaTools && WeaTools.ls && WeaTools.ls.getStr("staticVersion") || 0}`;

export const workflowPublicFiles = [
    `/spa/workflow/static4public/index.js${staticVersion}`,
    `css!/spa/workflow/static4public/index.css${staticVersion}`
];


export const smsFiles = [
    `/spa/smallApp/static/index.js${staticVersion}`,
    `css!/spa/smallApp/static/index.css${staticVersion}`
];

export const emailFiles = [
    `/spa/email/static/index.js${staticVersion}`,
    `css!/spa/email/static/index.css${staticVersion}`
];



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflow/constants/fileConfig.js